import { render, staticRenderFns } from "./AppScreenshots.vue?vue&type=template&id=6a19ec6f&scoped=true&"
import script from "./AppScreenshots.vue?vue&type=script&lang=js&"
export * from "./AppScreenshots.vue?vue&type=script&lang=js&"
import style0 from "./AppScreenshots.vue?vue&type=style&index=0&id=6a19ec6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19ec6f",
  null
  
)

export default component.exports